import React, { useContext, useEffect, useState } from "react";
import "../../styles/pages/Connections/Identity.scss";
import { abbreviateNumber } from "../../util/format";
import { mapIcons } from "./config/iconMap";
import { Loader } from "../../components/Loader/Loader";
import UserData from "../../store/User/UserData";
import { getAuthpointConnections } from "../../api/ApiClient";
import NotFound from "../../navigation/NotFound";
import { captureSentryError } from "../../util/sentry";
import { mapAuthpointValues } from "./config/connectionsMap";

const AuthpointConnection = () => {
  const [userData] = useContext(UserData);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const getConnections = async () => {
      setError(false);
      setLoading(true);
      try {
        let connectionsResponse = await getAuthpointConnections(
          userData?.tenant
        );
        setData(connectionsResponse);
      } catch (e) {
        captureSentryError(
          e,
          userData,
          "getAuthpointConnections API in Authpoint.js"
        );
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    userData?.tenant && getConnections();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.tenant]);

  return (
    <>
      <tr className={`connections-row identity authpoint`}>
        {loading ? (
          <td>
            <Loader />
          </td>
        ) : error ? (
          <NotFound isError dataError className="panel service" />
        ) : (
          <>
            <td className={"connection-type"}>
              <p className={"is-connected"}>IDENTITY</p>
              {data?.total_active_connections !== undefined && (
                <p className={"count"}>
                  {abbreviateNumber(data.total_active_connections, 0)}
                </p>
              )}
            </td>
            <td>
              <span
                className={
                  "circle " +
                  (!data?.total_active_connections ? "grey" : data?.status)
                }
              />
            </td>
            <td className={"service-icons"}>
              <img
                className={`identity-icon authpoint`}
                alt={"AuthPoint"}
                src={mapIcons("authpoint")}
              />
              <div className="authpoint-label">AuthPoint</div>
            </td>
            <td className={"connection-data"}>
              {mapAuthpointValues.map((elem, index) => {
                return (
                  <div key={index} className={"display-values"}>
                    <p className={"name"}>{elem.label}</p>
                    <p className={"value"}>
                      {elem.formatter(data[elem.field])}
                    </p>
                  </div>
                );
              })}
            </td>
          </>
        )}
      </tr>
    </>
  );
};

export default AuthpointConnection;
